import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';

import PropTypes from 'prop-types';

const propTypes = {
  count: PropTypes.number,
};

function Information({ count = 0 }) {
  const navigate = useNavigate();
  return (
    <button
      className="tv-information-icon__button"
      onClick={() => navigate('/information')}
    >
      <div style={{ position: 'relative' }}>
        <i
          className={`fa fa-info tv-information-icon ${count !== 0 ? 'tv-information-icon-active' : 'tv-information-icon-inactive'}`}
          aria-hidden="true"
        />
        {count > 0 && (
          <span className="tv-information-icon__count">{count}</span>
        )}
      </div>
    </button>
  );
}

Information.propTypes = propTypes;

const mapStateToProps = state => ({
  count: state.user.informationPages.filter(page => !page.IsRead).length || 0,
});

const mapDispatchToProps = dispatch => ({});
export default connect(mapStateToProps, mapDispatchToProps)(Information);
